import { BEIconProps } from './BEIconProps';
// import {StyledBEIcon} from './StyledBEIcon';
import { customIcons, faIcons } from './icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef, useMemo } from 'react';
import { StyledBEIcon } from './StyledBEIcon';

/* eslint-disable react/display-name */
const BEIcon = forwardRef<HTMLSpanElement, BEIconProps>(
  (
    {
      center = true,
      name,
      icon,
      color,
      size = 'md',
      weight = 'regular',
      ...rest
    },
    ref
  ) => {
    const child = useMemo(() => {
      let result: any = null;

      if (name) {
        result = customIcons[name] || (
          <FontAwesomeIcon icon={faIcons[name][weight]} />
        );
      }

      if (icon) {
        result = <FontAwesomeIcon icon={icon} />;
      }

      return result;
    }, [icon, name, weight]);

    return (
      <StyledBEIcon {...rest} center={center} size={size} ref={ref}>
        {child}
      </StyledBEIcon>
    );
  }
);

export default BEIcon;
